webpackJsonp([93222003207436],{

/***/ 330:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(33);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _fadeIn = __webpack_require__(28);
	
	var _fadeIn2 = _interopRequireDefault(_fadeIn);
	
	var _wordsModule = __webpack_require__(152);
	
	var _wordsModule2 = _interopRequireDefault(_wordsModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
		var data = _ref.data;
	
		var d = data.allMarkdownRemark.edges.filter(function (_ref2) {
			var node = _ref2.node;
	
			var reg = new RegExp('^/words/*');
			if (node.fields.slug) {
				return reg.test(node.fields.slug);
			}
			return null;
		});
	
		return _react2.default.createElement(
			'div',
			{ className: _wordsModule2.default.container },
			_react2.default.createElement(
				_fadeIn2.default,
				{
					x: {
						start: 40,
						end: 0,
						stiffness: 70,
						damping: 20
					}
				},
				_react2.default.createElement(
					'h1',
					null,
					'Words'
				),
				_react2.default.createElement(
					'h4',
					null,
					d.length,
					' Posts'
				),
				d.map(function (_ref3) {
					var node = _ref3.node;
					return _react2.default.createElement(
						'div',
						{ key: node.id, className: _wordsModule2.default.link },
						_react2.default.createElement(
							_gatsbyLink2.default,
							{ to: node.fields.slug },
							_react2.default.createElement(
								'p',
								{ className: _wordsModule2.default.date },
								node.frontmatter.date
							),
							_react2.default.createElement(
								'h3',
								{
									style: {
										display: 'inline',
										textDecoration: 'none'
									}
								},
								node.frontmatter.title
							),
							_react2.default.createElement(
								'p',
								{ className: _wordsModule2.default.excerpt },
								node.excerpt
							)
						)
					);
				})
			)
		);
	};
	
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 152:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-pages----words-module---container---2UGOR","link":"src-pages----words-module---link---1V5PU","date":"src-pages----words-module---date---2zM3o"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-words-js-3f9656e6121dcec49a99.js